import api from '../api';

const apiUrl = 'price-targets';

const state = {
    data: {},
    meta: {},
    filterStates: {}, // Map of all possible price target states for filtering
    activePriceTargets: 0 // Number of price targets with status Alternative Scenario, Approaching Target Zone or In the Target Zone
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((priceTargetsRaw) => {
                priceTargetsRaw.config.params?.key ? commit('setByKey', priceTargetsRaw) : commit('set', priceTargetsRaw);

                return priceTargetsRaw.data;
            })
            .catch((error) => {
                console.error(error);

                return Promise.reject(error);
            });
    },
    fetchFilterStates: async ({ commit }) => {
        const response = await api.get(`/api/v1/price-targets/filters`);
        commit('setFilterStates', response.data.status_map);
    },
    fetchActivePriceTargetsAmount: async ({ commit }) => {
        const response = await api.get(`/api/v1/dashboard-meta-data`);
        commit('setActivePriceTargets', response.data.activePriceTargetAmount);
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    },

    setByKey(state, response) {
        const key = response.config.params.key;

        if (state.data.hasOwnProperty(key)) {
            state.data[key].meta = response.data.meta;
            state.data[key].links = response.data.links;

            // only append if append_to_list is true
            response.data.data.length
                ? response.config.params?.page && response.config.params?.append_to_list
                    ? state.data[key].data.push(...response.data.data)
                    : (state.data[key].data = response.data.data)
                : (state.data[key].data = []);
        } else {
            state.data[key] = response.data;
        }
    },

    setFilterStates(state, statusMap) {
        state.filterStates = statusMap;
    },

    setActivePriceTargets(state, totalAmount) {
        state.activePriceTargets = totalAmount;
    }
};

const getters = {
    get: (state) => {
        return state;
    },
    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },
    getMeta: (state) => {
        return state.meta;
    },
    getFilterStates: (state) => {
        return state.filterStates;
    },
    getActivePriceTargetsAmount: (state) => {
        return state.activePriceTargets;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
